var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',[_c('v-card',{style:({
      'background-color': _vm.$vuetify.theme.dark
        ? 'rgba(0,0,0,0.6)'
        : 'rgba(255,255,255,0.95)'
    })},[_c('v-card-title',[_vm._v(" Leder: "+_vm._s(_vm.gruppe.gruppe.titel)+" "),_c('v-spacer'),_vm._v(" Abonnement kr.: "+_vm._s(_vm.gruppe.gruppe.type)+" ")],1),_c('v-card-text',[_c('v-data-table',{attrs:{"items":_vm.medlemmer,"headers":_vm.headers,"hide-default-footer":"","disable-pagination":""}})],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }